<template>
  <v-card-text>
    <v-layout
      column
      justify-center
      align-center
    >
      <v-layout mt-3>
        <p>{{ from ? '交換先の' : '設置する' }}センサーのシリアルナンバーを入力してください。</p>
        <p
          class="grey--text text--darken-2 ml-1 caption"
        >
          (例：ZZZ-9999)
        </p>
      </v-layout>
      <v-flex
        xs3
        style="min-height: 80px;"
      >
        <v-text-field
          ref="serialInput"
          :value="to"
          class="purple-input"
          label="シリアルNo"
          :rules="serialValidation"
          :error-messages="serialError"
          @input="fetchRecords($event)"
        />
      </v-flex>
    </v-layout>
  </v-card-text>
</template>

<script>
import { api } from '@/api.js'

export default {
  props: {
    from: {
      type: String,
      default: () => null
    },
    serialRegex: {
      type: RegExp,
      required: true
    }
  },
  data () {
    return {
      to: '',
      serialValidation: [(v) => this.serialRegex.test(v) || '形式が合っていません。'],
      serialError: []
    }
  },
  mounted () {
    this.$nextTick(() => this.$refs.serialInput.$refs.input.focus())
  },
  methods: {
    async fetchRecords (value) {
      this.serialError = []
      if (!this.serialRegex.test(value)) {
        this.$emit('setTo', null)
        return
      }
      try {
        const { sensor } = await api.getSensor(value)
        this.to = value
        if (sensor.installStatus) {
          this.serialError.push('既に使用中のセンサーです。')
        } else {
          this.$emit('setTo', { id: sensor.id, serialNo: this.to })
        }
      } catch (_) {
        this.serialError.push('センサーが見つかりません。')
      }
    }
  }
}
</script>
